import { Component } from 'react';
import { getAuthCredentials } from 'common/util/auth-storage';

import { SigningIframe } from 'part11/components/SigningIframe/SigningIframe';
import styles from './SignForm.scss';
import FileLink from 'common/components/FileLink/FileLink';
import { openPopup, listenForCredentials } from 'common/util/popup';
import { fetchSignUrl } from 'common/actions/login';

class SdfaSignForm extends Component {

    getSigningUrl() {
        const accessToken = getAuthCredentials().accessToken;
        return `${this.props.originUrl}/sign?access_token=${accessToken}&action_text=Sign Document and Complete Task`;
    }

    render() {
        const { onSignDocumentSubmit, document, signingStatement, viewDocument, isSSOSigningEnabled, isSsoUser, originUrl, addApplicationMessage } = this.props;
        const accessToken = getAuthCredentials().accessToken;
        const signingUrl = this.getSigningUrl();

        return (
            <div className={styles.container} data-cy="SdfaSignForm">
                <div className={styles.form}>
                    <h2 className={styles.title}  data-cy="SdfaSignForm-title">
                        <FileLink
                            document={document}
                            onClick={viewDocument}/>
                    </h2>
                    <h3 className={styles.label}>
                        Statement of Testament
                    </h3>
                    <p className={styles.statementOfTestament} data-cy="SdfaSignForm-p">
                        { signingStatement }
                    </p>
                </div>

                {isSSOSigningEnabled && isSsoUser ? (
                    <div className={styles.ssoWrapper}>
                        <button className={styles.ssoButton} onClick={() => {
                            fetchSignUrl(accessToken, true, originUrl).then(res => {
                                const popup = openPopup(res.provider_uri, 'sign');
                                listenForCredentials(popup)
                                    .then(res => onSignDocumentSubmit(res.token))
                                    .catch(err => addApplicationMessage('error', err.message || 'SSO authentication failed.'));
                            });
                        }}>
                            Authenticate with SSO to Sign
                        </button>
                    </div>
                ) : (
                    <SigningIframe
                        url={signingUrl}
                        signDocument={onSignDocumentSubmit}
                        data-cy="SdfaSignForm-SigningIframe"/>
                )}
            </div>
        );
    }
}

export default SdfaSignForm;
